import styled from 'styled-components';
import { Link } from '@chegg-ui/link';
import { colors, font, spacing, themes } from '@chegg-ui/theme';
import { Typography } from '@chegg-ui/typography';
export var LogoSC = styled.div.withConfig({
  componentId: "sc-1fcxlxv-0"
})(["display:flex;justify-content:center;align-items:center;margin-bottom:", ";"], spacing.px16);
export var LinkSC = styled(Link).withConfig({
  componentId: "sc-1fcxlxv-1"
})(["display:inline;color:", ";font-size:", ";font-weight:", ";line-height:", ";cursor:pointer;"], colors.violet700, font.size.px16, font.weight.normal, themes.horizon.font.lineHeight.lg);
export var FlexWrapperSC = styled.div.withConfig({
  componentId: "sc-1fcxlxv-2"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;max-width:", ";"], function (_ref) {
  var _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '100%' : _ref$maxWidth;
  return "".concat(maxWidth, "%");
});
export var MarginBottomSC = styled.div.withConfig({
  componentId: "sc-1fcxlxv-3"
})(["margin-bottom:", ";"], function (_ref2) {
  var _ref2$marginBottom = _ref2.marginBottom,
    marginBottom = _ref2$marginBottom === void 0 ? spacing.px8 : _ref2$marginBottom;
  return marginBottom;
});
export var TypographySC = styled(Typography).withConfig({
  componentId: "sc-1fcxlxv-4"
})(["text-align:center;"]);